import { css } from "../../css/util.compose-css";

export const scrambledMixin = () => css`
  background-color: transparent !important;
  background-image: url("data:image/svg+xml,%3Csvg width='1' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Crect opacity='0.1' id='scramble-bg' height='20' width='1' y='10' x='0' stroke-width='1.5' stroke='%23000' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A") !important;
  background-size: contain !important;
  background-repeat: repeat-x !important;

  color: rgb(0 0 0 / 0) !important;

  user-select: none !important;

  * {
    color: rgb(0 0 0 / 0) !important;
  }
`;
